// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".budgetbar__container[data-v-21deefa6]{width:100%;position:relative;display:flex}.budgetbar[data-v-21deefa6]{flex:1 0 auto;position:relative;margin-right:8px;display:flex}.budgetbar__bar[data-v-21deefa6]{background:#04f;height:16px}.budgetbar__bar--private[data-v-21deefa6]{background:#04f;opacity:.5}.budgetbar__amount[data-v-21deefa6]{flex:0 0 auto}.budgetbar__amount--other[data-v-21deefa6]{font-style:italic}tr:hover .budgetbar__bar[data-v-21deefa6]{background:#fff}", ""]);
// Exports
module.exports = exports;
